module.exports = __webpack_public_path__ + "img/radio-2.a9672f5d.jpg";